import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';

interface Props {
  type: DashboardConnectorType;
}

export const MiddleConnector: FC<Props> = ({ type }) => {
  const connectorColors = useUnitConnectorColors();
  const middleConnectors = {
    locked: (
      <svg width="170" height="15" viewBox="0 0 170 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="170" height="15" fill="#EBE4DC" />
      </svg>
    ),
    unlocked: (
      <svg width="170" height="15" viewBox="0 0 170 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_2296_30928" fill="white">
          <path d="M0 0H170V15H0V0Z" />
        </mask>
        <path
          d="M0 0V4H170V0V-4H0V0ZM170 15V11H0V15V19H170V15Z"
          className={connectorColors.fillBase}
          mask="url(#path-1-inside-1_2296_30928)"
        />
      </svg>
    ),
    passed: (
      <svg width="170" height="15" viewBox="0 0 170 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="170" height="15" className={connectorColors.fillBase} />
      </svg>
    ),
  };

  return middleConnectors[type];
};
